/* eslint-disable no-case-declarations */
/* eslint-disable eqeqeq */
export const types = {
  RESET: 'RESET_ERROR',
  RELOAD: 'RELOAD_ERROR',
};

export const getDraftId = () => '';

export const errorReducer = (state = [], action) => {
  switch (action.type) {
    case types.RELOAD:
      return action.payload;
    case types.RESET:
      return {};
    default:
      return state;
  }
};
